export const IMenu = {
  id: 2,
  name: 'Menu 1',
  images: [0, 1],
  image_type: 0,
  availability_type: 0,
  availability: { 1: { active: true, av_id: 2 } },
  stores: [56, 12],
  is_active: true,
  last_user_id: 32,
  is_archive: false,
  created_at: '2023-11-01T09:50:30.438Z',
  updated_at: '2023-11-01T09:50:30.438Z',
  archived_at: null,
}

export const IMenuCategory = {
  id: 1,
  menu_id: 1,
  name: 'Menu Category 1',
  image: [1, 2, 3],
  image_type: 1,
  colour: 'FF5733',
  availability_type: 0,
  availability: { 1: { active: true, av_id: 2 } },
  last_user_id: 32,
  is_archive: false,
  created_at: '2023-10-26T11:55:38.957Z',
  updated_at: '2023-10-26T11:55:38.957Z',
  archived_at: null,
  is_active: true,
  ord: 0,
}

export const IMenuItem = {
  id: 55,
  item_id: 2,
  category_id: 8,
  name: '',
  price: '0.000',
  availability_type: 0,
  availability: {},
  last_user_id: 32,
  is_archive: false,
  created_at: '2023-11-23T07:41:09.558Z',
  updated_at: '2023-11-23T07:41:09.558Z',
  archived_at: null,
  is_active: true,
  ord: 0,
}

export const IBusyMode = {
  id: 1,
  store_id: 56,
  busy_mode: true,
  busy_mode_until: '2024-03-26T08:31:19.000Z',
  last_user_id: 15,
  created_at: '2024-03-26T08:21:18.543Z',
  updated_at: '2024-03-26T08:21:18.543Z',
}

export const IMenuAvailability = {
  entity_id: 20,
  name: '',
  description: '',
  images: [],
  image_type: 0,
  entity_availability_id: 0,
  is_active: true,
  inactive_until: null,
}

export const IMenuItemAvailability = {
  entity_id: 574,
  name: 'A',
  description: '',
  images: [],
  image_type: 0,
  category_name: 'Beverages',
  entity_availability_id: 0,
  is_active: true,
  inactive_until: null,
}

export const IMenuModifierAvailability = {
  entity_id: 64,
  name: 'BBQ Sauce',
  description: '',
  category_name: 'Reza Test 2',
  entity_availability_id: 0,
  is_active: true,
  inactive_until: null,
}

export const IMenuEntityAvailability = {
  store_id: 56,
  entity_id: 39,
  entity_type: 'menu',
  is_active: false,
  inactive_until: '2024-03-26T13:28:34.000Z',
}
